import type { ReactNode } from 'react';

export const symbol_document_search: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-820v293-3 390-680 186-186Zm0 740q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h336q12.44 0 23.72 5T559-862l183 183q8 8 13 19.28 5 11.28 5 23.72v99q0 13.08-8.68 21.54-8.67 8.46-21.5 8.46-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-97H541q-12.75 0-21.37-8.63Q511-651.25 511-664v-156H180v680h313q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q505.75-80 493-80H180Zm558.5-141.5Q770-253 770-300t-31.5-78.5Q707-410 660-410t-78.5 31.5Q550-347 550-300t31.5 78.5Q613-190 660-190t78.5-31.5ZM864-66q-12 0-21-9l-86-86q-21 14-45.5 22.5T660-130q-70.83 0-120.42-49.62Q490-229.24 490-300.12t49.62-120.38q49.62-49.5 120.5-49.5t120.38 49.58Q830-370.83 830-300q0 27-8.5 51.5T799-203l86 86q9 9 9 21t-9 21q-9 9-21 9Z"
		/>
	</svg>
);
